import React, {Component} from 'react';
import { Checkbox, Radio } from 'react-icheck';
import PrintPreview from '../PrintPreview';
import TextFieldModal from 'component/element/TextFieldModal'
import PdfStore from 'stores/PdfStore';
import WorkdocStore from 'stores/WorkdocStore';
import '../Print.css'

var NotificationSystem = require('react-notification-system');

const doctitle = [{title:'ใบเคลม',doc:'copy_claim2'},{title:'ใบขับขี่',doc:'copy_driver_licence'},{title:'ตารางกรมธรรม์',doc:'copy_claim'},
  {title:'พรบ.',doc:'copy_insurance'},{title:'สำเนาทะเบียนรถ',doc:'copy_car'},{title:'บัตรเจ้าของรถ',doc:'copy_id'},{title:'เลขครัชซี',doc:'copy_chassis'},
  {title:'สัญญาประณีประนอมยอมความ',doc:'copy_compromise_agreement'}]
class PrintSSTWorkCoverFileDoc extends Component {

  constructor(...args){
    super(...args)
    this.state = {loading:false, data:{    
    car:{car_registration_no:'',brand:'',model:''},
    insurer:{insurer_id:'',insurer_name:'',claim_no:''},
    receiving:{entrance_date:'',entrance_name:'',title:'',entrance_name_as:'',tel:'',checking_by:'',openwork_by:''},
    delivering:{delivering_date:''},
    related_detail:{included_doc:this.getEmptyIncludeDoc(),part_from:'',lift_car_from:''
      ,additional_cost:{condition_cost:'',lift_cost:'',advance_lift_cost:'',other_cost:''}},
    doclist:doctitle.map((item,index)=>{
        return {title:item.title,checked:false,doc:item.doc}
      })
    }}

    var cssPagedMedia = (function() {
      var style = document.createElement('style');
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    }());

    cssPagedMedia.size = function(size) {
      cssPagedMedia('@page {size: ' + size + '}');
    };
    cssPagedMedia.size('portrait');
  }

  componentDidMount(){
    this._notificationSystem = this.refs.notificationSystem;
    this.loadWorkCoverFileDoc()
  }

  getEmptyIncludeDoc(){
    return {
      copy_car:false,
      copy_claim:false,
      copy_driver_licence:false,
      copy_id:false,
      copy_insurance:false,
      copy_other:false,
      copy_company_paper:false,
      copy_claim2:false,
      copy_compromise_agreement:false,
      other_text:''
    }
  }

  loadWorkCoverFileDoc() {
    let {workNo} = this.props
    let that = this
    this.setState({ loading: true })
    PdfStore.loadWorkCoverFileDoc(workNo,function(result) {
      let data = result.data

      if(data.related_detail.additional_cost!==undefined){
        data['related_detail']['additional_cost'] = data.related_detail.additional_cost
      }else{
        data['related_detail']['additional_cost'] = that.state.data.related_detail.additional_cost
      }
      if(data.related_detail.included_doc!==undefined){
        data.doclist = that.state.data.doclist.map((item,index)=>{
          if(item.doc in data.related_detail.included_doc){
            item.checked = data.related_detail.included_doc[item.doc]
          }
          
          return item
        })
      } else {
        data['related_detail']['included_doc'] = that.getEmptyIncludeDoc()
        data = JSON.parse(JSON.stringify(data))
      }
      
      data = Object.assign(that.state.data,data)
      that.setState({data:data})
    })  
  }

  saveParkingcarDoc(data){
    let {workNo} = this.props
    let that = this
    WorkdocStore.saveWorkdocRelated(workNo,'parking_doc',data.related_detail,function(result){
      that._notificationSystem.addNotification({
        title: 'แจ้งเตือน',
        message: 'ทำการบันทึกรายละเอียดใบปะหน้าแฟ้ม ' + workNo + ' เรียบร้อย',
        level: 'info',
        position: 'tc',        
      });
    },function(){
      that._notificationSystem.addNotification({
        title: 'แจ้งเตือน',
        message: 'มีความผิดพลาดเกิดขึ้นในการบันทึก ' + workNo + ' ',
        level: 'error',
        position: 'tc'
      });
    })
  }

  onCopyPaperChange(index){
    let {data} = this.state
    data.doclist[index].checked = !data.doclist[index].checked
    data.related_detail.included_doc[data.doclist[index].doc] = data.doclist[index].checked
    this.setState({data:data})
    this.saveParkingcarDoc(data)
  }

  onCheckChange(field,value){
    let {data} = this.state
    
    if (data['related_detail'][field]===value)
      value = ''

    data['related_detail'][field] = value
    this.setState({data:data})
    this.saveParkingcarDoc(data)
  }

  onOtherSave(fieldInfo){

    let {data} = this.state
    data['related_detail'].additional_cost[fieldInfo.item.field] = fieldInfo.value

    this.setState({data:data})

    this.saveParkingcarDoc(data)
  }

  onClick(item){
    let fieldInfo = {title:'ใส่ข้อมูล',showClear:true,item:item,value:item.cost }
    this.refs.textFieldModal.loadInfo(fieldInfo)
  }

  renderLogoUrl(logoUrl){
    let imgUrl = ''
    if (process.env.NODE_ENV == "development") {
      imgUrl = 'https://demo2.bigfix.co/korat/pdf/'+logoUrl
    }else{
      imgUrl = '../'+logoUrl
    }
    return (<img src={imgUrl} />)
  }

  renderComponentPage() {
    let {car,insurer,receiving,delivering,doclist,related_detail} = this.state.data
    let {part_from,lift_car_from,additional_cost} = related_detail
    return(
      <div className='font-print'>
        <header>
          <h2 className="text-right">{'ใบปะหน้าแฟ้ม'}</h2>
        </header>          
        <div className="font-30" style={{marginTop:'10px'}}>   
          <table className="table table-work-cover-file-doc">
            <tbody>
              <tr>
                <td style={{width:'80px'}}>บริษัท</td>
                <td className='hr2-b text-center color-work-cover-file-doc'>{insurer.insurer_name}</td>
                <td style={{width:'50px'}}>รหัส</td>
                <td style={{fontSize:'40px'}} className='hr2-b hr2-b-print text-center color-work-cover-file-doc work-no'>{this.props.workNo}</td>
              </tr>  
            </tbody>
          </table>
          <table className="table table-work-cover-file-doc">
            <tbody>      
              <tr>
                <td style={{width:'80px'}} className='w-c1'>ยี่ห้อรถ</td>
                <td className='hr2-b hr2-b-print text-center'>{car.brand+'/'+car.model}</td>
                <td style={{width:'110px'}} className='w-c2'>ทะเบียนรถ</td>
                <td className='hr2-b text-center'>{car.car_registration_no}</td>
              </tr>
            </tbody>
          </table>    
          <table className="table table-work-cover-file-doc">
            <tbody>    
              <tr>
                <td style={{width:'90px'}} className='w-c3'>เลขเคลม</td>
                <td className='hr2-b text-center hr2-b-print' >{insurer.claim_no}</td>
                <td style={{width:'90px'}} className='w-c3'>พนักงาน</td>
                <td className='hr2-b text-center hr2-b-print' >{receiving.checking_by}</td>
              </tr>
            </tbody>
          </table>    
          <table className="table table-work-cover-file-doc">
            <tbody>    
              <tr>
                <td style={{width:'100px'}} className='w-c3'>ยกรถจาก</td>
                <td className='text-left' colSpan={3}>
                <Checkbox
                    onChange={this.onCheckChange.bind(this,'lift_car_from','garage')}
                    checked={lift_car_from=='garage'}
                    checkboxClass={'icheckbox_square-blue '+(lift_car_from=='garage'?'checkbox-check':'')}
                    increaseArea="20%"
                    label=" อู่"
                  /><Checkbox
                  onChange={this.onCheckChange.bind(this,'lift_car_from','other')}
                  checked={lift_car_from=='other'}
                  checkboxClass={'icheckbox_square-blue '+(lift_car_from=='other'?'checkbox-check':'')}
                  increaseArea="20%"
                  label=" ที่อื่น"
                /></td>
              </tr>
            </tbody>
          </table>             
          <table className="table table-work-cover-file-doc">
            <tbody>    
              <tr>
                <td style={{width:'150px'}} className='w-c5'>เบอร์โทรลูกค้า</td>
                <td className='hr2-b text-center' >{receiving.tel}</td>
                <td style={{width:'150px'}} className='w-c5'>เบอร์โทรลูกค้า</td>
                <td className='hr2-b text-center' >{receiving.other_tel}</td>
              </tr>
              <tr>
                <td colSpan={4}>
                <Checkbox
                    onChange={this.onCheckChange.bind(this,'part_from','garage')}
                    checked={part_from=='garage'}
                    checkboxClass={'icheckbox_square-blue '+(part_from=='garage'?'checkbox-check':'')}
                    increaseArea="20%"
                    label=" อู่จัดอะไหล่"
                  />
                &nbsp;  
                <Checkbox
                  onChange={this.onCheckChange.bind(this,'part_from','insurer')}
                  checked={part_from=='insurer'}
                  checkboxClass={'icheckbox_square-blue '+(part_from=='insurer'?'checkbox-check':'')}
                  increaseArea="20%"
                  label=" ประกันจัด"
                />
                </td>
              </tr>
            </tbody>
          </table>  
          <table className="table table-work-cover-file-doc">
            <tbody>    
              <tr>
                <td style={{width:'90px'}} className='w-c3'>รถเข้า</td>
                <td className='hr2-b text-center hr2-b-print' >{receiving.entrance_date}</td>
                <td style={{width:'90px'}} className='w-c3'>รถออก</td>
                <td className='hr2-b text-center hr2-b-print' >{delivering.delivering_date}</td>
                <td style={{width:'90px'}} className='w-c3'>ตั้งเบิก</td>
                <td className='hr2-b text-center hr2-b-print' >{''}</td>
              </tr>
            </tbody>
          </table> 
          <table className="table table-work-cover-file-doc font-20" style={{fontSize:'20px'}}>
            <tbody>    
              <tr>
                <td style={{width:'110px'}} className='w-c3 detail-2'>เสนอราคาวันที่</td>
                <td className='hr2-b text-center hr2-b-print' >{''}</td>
                <td style={{width:'120px'}} className='w-c3 detail-2'>สั่งอะไหล่วันที่(1)</td>
                <td className='hr2-b text-center hr2-b-print' >{''}</td>
                <td style={{width:'120px'}} className='w-c3 detail-2'>สั่งอะไหล่วันที่​(2)</td>
                <td className='hr2-b text-center hr2-b-print' >{''}</td>
              </tr>
            </tbody>
          </table> 
          <table className="table table-work-cover-file-doc font-20">
          <tbody>    
            <tr>
              <td style={{width:'110px'}} className='w-c3 detail-2'>อนุมัติอะไหล่วันที่</td>
              <td className='hr2-b text-center hr2-b-print' >{''}</td>
              <td style={{width:'120px'}} className='w-c3 detail-2'>ร้านอะไหล่</td>
              <td className='hr2-b text-center hr2-b-print' >{''}</td>
              <td style={{width:'120px'}} className='w-c3 detail-2'>โทร</td>
              <td className='hr2-b text-center hr2-b-print' >{''}</td>
            </tr>
          </tbody>
        </table>
        <table className="table table-work-cover-file-doc font-20">
          <tbody>    
            <tr>
              <td style={{width:'110px'}} className='w-c3 detail-2'>ผู้เปิดเรื่องวันที่</td>
              <td className='hr2-b text-center hr2-b-print' colSpan={2}>{receiving.entrance_date}</td>
              <td style={{width:'120px'}} className='w-c3 detail-2'>ผู้เปิดเรื่อง</td>
              <td className='hr2-b text-center hr2-b-print' colSpan={2}>{receiving.openwork_by}</td>
            </tr>
            <tr>
            <td className='text-center detail-2' colSpan={2}>
                <Radio
                        onChange=""
                        checked={car.accident_type==='รถประกัน'}
                        radioClass={'iradio_square-blue '+(car.accident_type==='รถประกัน'?'radio-check':'')}
                        increaseArea="20%"
                        label=" ประกัน"
                      >
                      </Radio>
                      &nbsp;
                      <Radio
                        onChange=""
                        checked={car.accident_type==='คู่กรณี'}
                        radioClass={'iradio_square-blue '+(car.accident_type==='คู่กรณี'?'radio-check':'')}
                        increaseArea="20%"
                        label=" คู่กรณี"
                      >
                      </Radio>
                
                 </td>
            </tr>
          </tbody>
        </table>        
          <div style={{width:'100%'}}>
            <div style={{float:'left',width:'50%'}}>
              <table className="table table-left-work-cover-file-doc">
                <tbody>
                  {
                  doclist.map((item,index)=>(
                    <tr key={index}>
                      <td className='w-claims-doc'>
                        <Checkbox
                          onChange={this.onCopyPaperChange.bind(this,index)}
                          checked={item.checked}
                          checkboxClass={'icheckbox_square-blue '+(item.checked?'checkbox-check':'')}
                          increaseArea="20%"
                          label={" "+item.title}
                        >
                        </Checkbox>
                      </td>
                   </tr>
                  ))}                  
                </tbody>
              </table>  
            </div>
            <div style={{float:'right',width:'50%'}}>
              <table className="table table-right-work-cover-file-doc" style={{border:"2px solid black"}}>
                <tbody>
                  {
                    [{title:'ค่าเงื่อนไข',field:'condition_cost',cost:''},
                    {title:'ค่ายก',field:'lift_cost',cost:''},
                    {title:'สำรองค่ายก',field:'advance_lift_cost',cost:''},
                    {title:'เพิ่มเติม',field:'other_cost',cost:''}].map((item,index)=>(
                      <tr key={index}>
                        <td className='font-22'>
                          {item.title}
                        </td>
                        <td>
                          <span onClick={this.onClick.bind(this,item)}>...{(additional_cost[item.field]!=='')?additional_cost[item.field]:'.....................'}...บาท</span>
                        </td>
                      </tr>
                    ))
                  }                  
                </tbody>
              </table>
              <table className="table table-work-cover-file-doc">
                <tbody>
                  <tr>
                    <td className='td-appointment-date' style={{fontSize:'22px',width:'150px'}}>วันนัดเข้าซ่อมล่วงหน้า</td>
                    <td className='hr2-b color-work-cover-file-doc'>{receiving.advance_date}</td>
                  </tr>
                  <tr>
                    <td><br /></td>
                  </tr>
                  <tr>
                    <td className='td-appointment-date' style={{fontSize:'22px'}}>วันที่นัดรับรถ</td>
                    <td className='hr2-b color-work-cover-file-doc'>{receiving.appointment_date}</td>
                  </tr>              
                </tbody>
              </table> 
            </div>
          </div>          
          <TextFieldModal ref='textFieldModal'
            confirmTitle='บันทึก'
            onConfirm={this.onOtherSave.bind(this)}
            />
         <NotificationSystem ref="notificationSystem" />                  
        </div>
      </div>  
    )
  }

  render() {
    let {loading} = this.state
    return(
      <PrintPreview 
        loading={loading} 
        leftBarTitle={'ใบปะหน้าแฟ้ม '+this.props.workNo}>
        {this.renderComponentPage()}
      </PrintPreview>
    )
  }

}  

PrintSSTWorkCoverFileDoc.defaultProps = {
  title: 'ใบปะหน้าแฟ้ม',  
  mode : '1'
}
export default PrintSSTWorkCoverFileDoc;


// WEBPACK FOOTER //
// ./src/view/print/sst/PrintSSTWorkCoverFileDoc.js